export const OPEN_INFO_MODAL_WINDOW = 'OPEN_INFO_MODAL_WINDOW';
export const CLOSE_INFO_MODAL_WINDOW = 'CLOSE_INFO_MODAL_WINDOW';

export const SET_INIT_PATH = 'SET_INIT_PATH';

export const ADD_ALERT = 'ADD_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const CLEAR_ALERTS = 'CLEAR_ALERTS';
